<template>
  <div class="home" v-loading="loading">
    <!--    轮播图-->
    <div id="swiperBox" :options="swiperOption" ref="mySwiper" style="cursor: auto">
      <div
        class="swiper-slide slide-two"
        :style="{ background: ' url(' + banner + ') no-repeat center center' }"
      >
        <div class="type-center swiper-no-swiping">
          <div class="page p15">
            <h5>找写字楼</h5>
            <div class="search mt10 flex ju-sp">
              <div>
                <el-input
                  class="input1"
                  style="width: 305px; height: 100%; padding: 5px"
                  placeholder="请输入写字楼名称"
                  prefix-icon="el-icon-search"
                  v-model="search"
                >
                </el-input>
              </div>
              <div class="but" @click="handleSearchClick">搜索</div>
            </div>
            <div class="ptb15" style="border-bottom: 1px solid #dddddd">
              <h6>选择区域</h6>
              <div class="flex war-pe">
                <div
                  class="region"
                  :class="item.value == regionId ? 'txt1' : 'txt'"
                  v-for="(item, index) in regionList"
                  :key="index"
                  @click="regionClick(item)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="ptb10">
              <h6>选择面积</h6>
              <el-slider
                v-model="area"
                range
                :max="1500"
                :marks="marks"
                :format-tooltip="formatTooltip"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    热门商圈-->
    <div class="mtb15 type-center" v-if="viceDistrict || mainDistrict">
      <su-title title="热门商圈" description="黄金地段商业配置成熟" :border="false" />
      <div class="businessDistrict flex mt15">
        <div class="businessDistrict-left" @click="onClickDistrict(mainDistrict)">
          <div class="content">
            <img :src="mainDistrict.image_url" alt="" />
            <div class="introduce">{{ mainDistrict.name }}</div>
          </div>
        </div>
        <div class="businessDistrict-right flex war-pe">
          <div
            v-for="(item, index) in viceDistrict"
            :key="index"
            class="content"
            style="margin: 0 0 20px 27px"
            @click="onClickDistrict(item)"
          >
            <img :src="item.image_url" alt="" />
            <div class="introduce">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <!--    精选写字楼-->
    <div class="officeBuilding ptb15" v-if="buildings">
      <div class="type-center">
        <su-title
          title="精选写字楼"
          description="精准匹配 比您更懂您"
          @seeMoreClick="$router.push({ path: '/lease' })"
        />
        <div class="mt15 flex ju-sp al-cn war-pe">
          <div
            class="officeBuilding-box mb10"
            v-for="(building, index) in buildings"
            :key="index"
            @click="onClickBuilding(building)"
          >
            <!--            <img class="img" :src="building.image_url"/>-->
            <el-image :src="building.image_url" alt="">
              <div slot="error" class="image-slot">
                <el-empty description="暂无图片"></el-empty>
              </div>
            </el-image>
            <div class="ptb5 plr10">
              <div class="title pb5">{{ building.name }}</div>
              <div class="flex ju-sp">
                <div>
                  <span class="price">{{ building.rent_price }}</span>
                  <span class="position">元/㎡-天</span>
                </div>
                <div class="position flex al-cn">
                  <img
                    src="@/assets/icon/position.png"
                    style="width: 20px; height: 20px"
                    alt=""
                  />
                  <div class="ml3">{{ building.address }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    立即委托-->
    <contracts @searchClick="searchClick" />
  </div>
</template>

<script>
import * as Api from "@/api/api";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import SuTitle from "@/components/su-title.vue";
import { observer } from "@/utils/util";
import contracts from "@/components/contracts.vue";

export default {
  name: "HelloWorld",
  components: {
    SuTitle,
    swiper,
    swiperSlide,
    contracts,
  },
  data() {
    return {
      search: "", // 搜索
      loading: false,
      regionId: "",
      // 地区列表
      regionList: [{ value: "", name: "不限" }],
      buildings: [],
      value: [4, 8],
      area: "", //面积
      areaList: ["0", "100㎡", "300㎡", "500㎡", "700㎡", "1000㎡", "1000㎡以上"], //面积列表
      mainDistrict: {},
      viceDistrict: [],
      //顶部轮播图配置，
      swiperOption: {
        // 自动切换
        autoplay: {
          // 停留时间
          delay: 3000,
          // 用户操作swiper之后，是否禁止autoplay
          disableOnInteraction: false,
        },
        pagination: true,
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
      },
      //动画效果
      animationEffect: [
        "zoomIn",
        "fadeInDown",
        "fadeInUp",
        "fadeInLeft",
        "fadeInRight",
        "backInUp",
        "backInLeft",
        "backInRight",
      ],
      phone: "",
      marks: {
        0: "0",
        100: "100m²",
        300: "300m²",
        500: "500m²",
        700: "700m²",
        1000: "1000m²",
        1300: "1000m²以上",
      },
      banner: "../assets/img/home_do.jpg",
    };
  },
  created() {
    this.getStoreData();
    this.getArea();
    this.getDistrict();
    this.getBuildings();
  },
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    this.animationEffect.forEach((item) => {
      // 获取所有的 div
      const effect = document.querySelectorAll("." + item);
      effect.forEach((div) => {
        // 循环添加监听
        observer.observe(div);
      });
    });
  },
  methods: {
    getStoreData() {
      Api.storeData().then(({ data }) => {
        this.banner = data.storeInfo.Image.preview_url;
      });
    },
    getArea() {
      Api.area().then(({ data }) => {
        // 通知父端组件提交完成了
        var list = data.list;
        list.forEach((area) => {
          this.regionList.push({ value: area.id.toString(), name: area.name });
        });
      });
    },

    getDistrict() {
      Api.district().then(({ data }) => {
        // 通知父端组件提交完成了
        var list = data.list;
        list.forEach((district, index) => {
          if (index == 1) {
            this.mainDistrict = district;
          } else {
            this.viceDistrict.push(district);
          }
        });
      });
    },

    getBuildings() {
      Api.homeBuildings().then(({ data }) => {
        // 通知父端组件提交完成了
        this.buildings = data.list;
      });
    },
    handleSearchClick() {
      this.$router.push({
        path: "/lease",
        query: {
          minArea: this.area[0],
          maxArea: this.area[1],
          regionId: this.regionId,
          search: this.search,
        },
      });
    },
    onClickDistrict(val) {
      // this.$router.push({
      //   path: "/lease",
      //   query: {
      //     district_id: val.id,
      //     district_name: val.name,
      //   },
      // });
      this.$router.push({
        path: "/lease/business",
        query: {
          district_id: val.id,
          district_name: val.name,
        },
      });
    },
    onClickBuilding(val) {
      this.$router.push({
        path: "/lease/detail",
        query: {
          building_id: val.id,
        },
      });
    },
    //搜索
    searchClick() {
      this.$emit("searchClick", this.phone);
    },
    //区域选择
    regionClick(e) {
      this.regionId = e.value;
    },
    // 面积
    formatTooltip(val) {
      return val + "㎡";
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  //font-family: PingFangSC, PingFang SC;
}

.swiper-slide {
  font-size: 24px;
  height: 478px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .page {
    //overflow: hidden;
    width: 420px;
    height: 390px;
    background: #ffffff;
    border-radius: 21px;
    opacity: 0.97;

    .search {
      width: 417px;
      height: 49px;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #6db84f;

      .but {
        width: 104px;
        height: 49px;
        background: #6ebb53;
        border-radius: 8px;
        font-size: 16px;
        font-family: SourceHanSansSC, SourceHanSansSC;
        font-weight: 500;
        color: #ffffff;
        line-height: 49px;
        text-align: center;
      }
    }

    .region {
      font-size: 16px;
      font-family: SourceHanSansSC, SourceHanSansSC;
      font-weight: 400;
      padding: 20px 30px 0 0;
      cursor: pointer;
      &:hover {
        color: #6ebb53;
      }
    }

    .txt {
      color: #414141;
    }

    .txt1 {
      color: #6ebb53;
    }

    .area {
      font-size: 14px;
      font-family: SourceHanSansSC, SourceHanSansSC;
      font-weight: 500;
      color: #7f7f7f;
      padding-right: 19px;
    }
  }
}

.slide-one {
  background: url(../assets/image/laboratory.png) no-repeat center;
  background-size: cover;
}

.slide-two {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}

.slide-three {
  background: url(../assets/img/home_anli.jpg) no-repeat center;
  background-size: cover;
}

.businessDistrict {
  &-left {
    img {
      width: 584px;
      height: 584px;
      border-radius: 8px;
    }
  }

  &-right {
    img {
      width: 360px;
      height: 282px;
      border-radius: 8px;
    }
  }

  .content {
    position: relative;

    .introduce {
      width: 100%;
      background-color: rgba(0, 0, 0, 0.4);
      border-radius: 8px;
      position: absolute;
      bottom: 0;
      left: 0;
      height: 54px;
      text-align: center;
      line-height: 54px;
      font-size: 18px;
      font-family: SourceHanSansSC, SourceHanSansSC;
      font-weight: 500;
      color: #ffffff;
    }
  }
}

.officeBuilding {
  font-family: SourceHanSansSC, SourceHanSansSC;
  background-color: #f7f7f7;

  &-box {
    background: #ffffff;
    border-radius: 8px;
    width: 322px;

    img {
      width: 100%;
      height: 250px;
      border-radius: 8px;
    }

    .title {
      font-size: 18px;
      font-weight: 500;
      color: #000000;
    }
  }
}
</style>
